import type { Event } from "./types";

export async function fetchEvent(): Promise<Event> {
  try {
    const res = await fetch("/data/event.json", { cache: "no-cache" });
    return await res.json();
  } catch (err) {
    console.error("Impossible de charger event.json", err);
    return {
      date: "2026-04-12",
      start: "13h",
      location: "Ramonville",
    };
  }
}
  